import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, Button, Divider, Spinner, StackView, Typography } from '@telus-uds/components-web';

import request from '../utils/request';
import { Container, TopBarWrapper } from './css';
import { initialFiltersValue, getFormattedPayload } from './utils';
import { CONSTANT } from '../utils/constant';

import Search from './components/search';
import UserBlock from './components/userBlock';
import Pagination from '../salesRepDashboard/Pagination';
import UserDetails from './components/userDetails';
import Filters from './components/filters';
import ExportReport from './components/exportReport';

export default function ManageAccount({ match: { params } }) {
  const {
    KEYS: {
      ROLES: { ADMIN_TIME_TRACKING }
    }
  } = CONSTANT;
  const history = useHistory();
  const { userId } = params;
  const {
    role: { name: loggedInUserRole }
  } = request.getProfile();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userCount, setUserCount] = useState(0);
  const [filters, setFilters] = useState(initialFiltersValue);
  const [searchQuery, setSearchQuery] = useState('');
  const [pageNumber, setPageNumber] = useState(1);

  const isTimeTrackingToolUser = loggedInUserRole === ADMIN_TIME_TRACKING;

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const usersData = await request.post('/users/filter', {
        ...getFormattedPayload(filters),
        page: pageNumber,
        q: searchQuery
      });
      setUsers(_.get(usersData, 'data.users', []));
      setUserCount(_.get(usersData, 'data.count', []));
      if (usersData) setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [searchQuery, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
  }, [searchQuery]);

  let userData;
  if (userId && users.length > 0) {
    userData = users && users.find(user => +user.id === +userId);
    if (!userData) history.push('/users');
  }

  return (
    <Container>
      {userId && userData && (
        <UserDetails userData={userData} fetchUsers={fetchUsers} />
      )}
      <StackView space={4}>
        <Typography heading="h2" variant={{ size: 'h2' }} block>Manage Account ({userCount})</Typography>
        {!isTimeTrackingToolUser && (
          <Filters
            filters={filters}
            setFilters={setFilters}
            setUsers={setUsers}
            setUserCount={setUserCount}
            setLoading={setLoading}
          />
        )}
        <TopBarWrapper>
          {!isTimeTrackingToolUser && (
            <Button
              variant={{ priority: 'high' }}
              onPress={() => history.push('/bulk-upload')}
            >
              Bulk upload
            </Button>
          )}
          <Search searchQuery={searchQuery} setQueryString={setSearchQuery} />
        </TopBarWrapper>
        {!loading && users.length === 0 ? (
          <Typography heading="h4" variant={{ size: 'h4' }} block>No user found</Typography>
        ) : (
          <Spinner label="Fetching users..." show={loading} inline>
            <Divider space={0} variant={{ inverse: true }} />
            <p style={{ fontWeight: '600' }}>
              Showing results {(pageNumber - 1) * 100 + 1} -{' '}
              {pageNumber * 100 <= userCount ? pageNumber * 100 : userCount} of{' '}
              {userCount}
            </p>
            <UserBlock users={users} fetchUsers={fetchUsers} />
            <Pagination
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              ordersPerPage={100}
              totalOrders={userCount}
            />
            {!isTimeTrackingToolUser && <ExportReport filters={filters} />}
          </Spinner>
        )}
      </StackView>
    </Container>
  );
}

ManageAccount.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      userId: PropTypes.number
    })
  }).isRequired
};
